import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Dashboard from "../../../layouts/Dashboard";
import {
  usePlanCategoriesQuery,
  usePlansQuery,
} from "../../../apis/subscriptionApi.hooks";
import { useFeatureFlag } from "../../../context/features";
import { PLAN_CREATE_FEATURE_FLAG } from "../../../context/features/features.utils";
import { usePlans } from "../PlansProvider/PlansProvider";
import useUrlSearchParams from "../../../hooks/useUrlSearchParams";
import styles from "./PlanList.module.scss";
import PlansListHeader from "./PlanListHeader";
import PlanListLoader from "./PlanListLoader";
import ActivePlanList from "./ActivePlanList";
import DeletedPlanList from "./DeletedPlanList";
import { Plan } from "src/apis/subscriptionApi";

export function PlansListContent() {
  const { isFeatureEnabled } = useFeatureFlag();
  const createPlanFlag = isFeatureEnabled(PLAN_CREATE_FEATURE_FLAG);

  const { startPlanCreation, startPlanEdition, startPlanCategoryCreation } =
    usePlans();

  const { planUuid } = useUrlSearchParams<{ planUuid: string }>();

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const {
    data: { data: categories = [] } = {},
    isLoading: isCategoriesLoading,
    refetch: refetchCategories,
  } = usePlanCategoriesQuery();

  const {
    data: plans = [] as Plan[],
    isLoading: isPlansLoading,
    refetch: refetchPlans,
  } = usePlansQuery(["activeSubscriptionsCount"]);

  const handleCreatePlan = () => {
    startPlanCreation({ onSuccess: refetchPlans });
  };

  const handleCreateCategory = () => {
    startPlanCategoryCreation({ onSuccess: refetchCategories });
  };

  // Start plan edition if planUuid is present in the URL
  useEffect(() => {
    if (planUuid) {
      startPlanEdition({ planUuid, onSuccess: refetchPlans });
    }
  }, [planUuid, refetchPlans, startPlanEdition]);

  const isLoading = isCategoriesLoading || isPlansLoading;

  return (
    <>
      <div className="p-4">
        <PlansListHeader
          createPlanFlag={createPlanFlag}
          selectedTabIndex={selectedTabIndex}
          onChangeTabIndex={setSelectedTabIndex}
          onCreateCategoryClick={handleCreateCategory}
          onCreatePlanClick={handleCreatePlan}
        />
      </div>
      {isLoading && <PlanListLoader />}
      <div className={styles.root}>
        {selectedTabIndex === 0 && (
          <ActivePlanList
            categories={categories}
            plans={plans}
            refetchCategories={refetchCategories}
            refetchPlans={refetchPlans}
          />
        )}
        {selectedTabIndex === 1 && (
          <DeletedPlanList plans={plans} refetchPlans={refetchPlans} />
        )}
      </div>
    </>
  );
}

function PlansList() {
  return (
    <>
      <Helmet>
        <title>Plans</title>
      </Helmet>
      <Dashboard scrollableContent disableContentPadding>
        <PlansListContent />
      </Dashboard>
    </>
  );
}

export default PlansList;
